<template>
	<div>
		<v-menu
			top
			:close-on-content-click="false"
			:close-on-click="false"
			:nudge-right="-10"
			:nudge-bottom="66"
			nudge-top="10"
			left
			:value="quickmenu"
			attach="#chat__quickmenu-btn"
			min-width="380"
			max-width="380"
			absol
		>
			<v-card v-if="!newMessagePopup" class="chat__quickmenu">
				<chats-list @openRoom="openRoom" @openNewMessagePopup="openNewMessagePopup" @toggleMenu="toggleMenu" expand minimize/>
			</v-card>
			<chat-window
				v-if="newMessagePopup"
				begin-chat
				ref="newMessage"
				:bubble="true"
				@close="closeNewMessagePopup()"
				/>
		</v-menu>
		<div id="chat__quickmenu-btn">
			<v-btn
				@click="toggleMenu()"
				fab
				text
				class="shadow chat__quickmenu-btn"
				:class="{active: quickmenu}"
			>
				<v-badge
					v-if="unreadMessagesCount"
					overlap
					bordered
					top
					dot
					offset-y="-1"
					offset-x="-16"
					color="red"
					style="z-index: 1"
					:content="unreadMessagesCount"
				>
				</v-badge>
				<v-icon :color="quickmenu ? 'white' : 'primary'">
					$envelope
				</v-icon>
			</v-btn>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import ChatsList from '@/components/chat/messenger/ChatsList';
import ChatWindow from '@/components/chat/ChatWindow';
export default {
	components: {
		ChatsList,
		ChatWindow
	},
	data() {
		return {
			fab: false,
			selectedRoom: null,
			filters: {
				search: ''
			},
			loadings: {
				search: false
			},
			newMessage: false,
		}
	},
	computed: {
		...mapGetters({
			unreadMessagesCount: 'chat/unreadMessagesCount',
			rooms: 'chat/rooms',
			bubbleRooms: 'chat/bubbleRooms',
			quickmenu: 'chat/quickmenu',
			totalExpandedWidth: 'chat/totalExpandedWidth',
			popupWidth: 'chat/popupWidth',
			popupPadding: 'chat/popupPadding',
			newMessagePopup: 'chat/newMessagePopup',
			bubbleRoomsExpanded: 'chat/bubbleRoomsExpanded'
		})
	},
	methods: {
		openNewMessagePopup() {
			this.$store.commit('chat/openNewMessagePopup');
			this.$nextTick(() => {
				if(this.$refs.newMessage) {
					this.$refs.newMessage.setActive();
				}
			})
		},
		closeNewMessagePopup() {
			this.$store.commit('chat/closeNewMessagePopup');
		},
		search() {
			console.log("SEARCH", this.filters.search)
		},
		toggleMenu() {
			this.$store.commit('chat/setQuickmenu', !this.quickmenu)
		},
		openRoom(room) {
			this.toggleMenu();
			this.$store.commit('chat/addBubble', room);
			this.$nextTick(() => {
				let roomStatus = this.rooms.find(x => x.id == room.id);
				if(!roomStatus.bubble_expanded) {
					if(this.$vuetify.breakpoint.width > this.totalExpandedWidth + this.popupWidth + this.popupPadding) {
						this.$store.commit('chat/expandBubble', room);
						setTimeout(() => {
							this.$store.commit('chat/setBubbleActive', room)
						}, 100)
					}
					else {
						// this.$snackbar.error( this.$vuetify.lang.t('$vuetify.views.chat.errors.tooManyExpanded'));
						this.$store.commit('chat/setPopupRoomNotFitting', room);
					}
				}
				else {
					setTimeout(() => {
						this.$store.commit('chat/setBubbleActive', room)
					}, 100)
				}

			})
		}
	}
}
</script>

<style lang="scss">
	.chat__quickmenu-btn {
		background: white;
		&.active.v-btn {
			background-color: var(--v-primary-base);
		}
	}
	.chat__quickmenu-body {
		min-height: 405px;
		max-height: 405px;
		overflow-y: auto;
		padding: 0;

		.v-list-item {
			padding-top: 10px;
			padding-bottom: 10px;

			.username {
				font-weight: bold;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
			}

			&:hover {
				background-color: var(--v-accent-lighten2) !important;
			}
		}
	}
</style>
